/* eslint-disable */
import React from 'react';
import NewPage from '../components/NewPage';
import DashboardContainer from '../containers/DashboardContainer';

const MainPage = () => {
  return (
    <NewPage title="관리 현황">
      <DashboardContainer />
    </NewPage>
  );
};

export default MainPage;
